import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { Transfer, FileUploadOptions, TransferObject } from '@ionic-native/transfer';



@Injectable()
export class Api {
 
  //https://us-east-1.aws.webhooks.mongodb-stitch.com/api/client/v2.0/app/drbeen-stage-zujks/service/userService/incoming_webhook/getUsersByType
  // live server BASE url....................................................
  public static live_url = 'https://us-east-1.aws.webhooks.mongodb-stitch.com/api/client/v2.0/app/drbeen-stage-zujks/service';
  
  //private static live_user_webhooks = "/incoming_webhook";
  ///videoLibrary';

  headers: any = {
   
    "Content-Type": "application/json",
    "Accept": "application/json"
  };

  constructor(public http: HttpClient) {
    
  }

  

  get(endpoint: string, params?: any, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    // Support easy query params for GET requests
    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params.set(k, params[k]);
      }
    }
    return this.http.get(Api.live_url+ '/' + endpoint, reqOpts);
  }

  post(endpoint: string, body: any) {
  //  console.log(JSON.stringify(body));
   // console.log(Api.live_url + '/' + endpoint)
    return this.http.post(Api.live_url + '/' + endpoint, body);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    console.log(Api.live_url + '/' + endpoint)
    return this.http.put(Api.live_url + '/' + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    console.log(Api.live_url + '/' + endpoint)
    return this.http.delete(Api.live_url + '/' + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    console.log(Api.live_url + '/' + endpoint)
    return this.http.put(Api.live_url + '/' + endpoint, body, reqOpts);
  }
}
